import actions from './actions';
import {IAction, TFilters} from "../../types";

type TSert = {
    title: string,
    descriptions: string,
    webLink: string,
    url: string,
    images: string[]
}
const initialState = {
    cert: [],
    isEmailSanded: false,
    firstLoad: false,
    isFetching: false
};
export type TInfoState = {
    cert: TSert[],
    isFetching: boolean,
    firstLoad: boolean,
    isEmailSanded: boolean
    options: {
        label: string,
        value: string
    }[]
}
export default function info(state = initialState, action: IAction) {
    const { type, data } = action;
    switch (type) {

        case actions.SET_VALUE:
            return {
                ...state,
                ...data
            }
        case actions.GET_CERTIFICATIONS_SUCCESS: {
            if (!Array.isArray(data)) return { ...state, cert: [] };
            return {
                ...state,
                cert: data.map((item: any) => ({
                    title: item.category,
                    descriptions: item.description,
                    webLink: item.link,
                    url: item.items?.[0]?.img ?? '',
                    images: item.items?.map((i: any) => i.img) ?? []
                }))
            };
        }
        case actions.SEND_EMAIL_SUCCESS:
            return {
                ...state,
                isEmailSanded: true
            }
        default:
            return state;
    }
}
